import script from "./DialogManager.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogManager.vue?vue&type=script&setup=true&lang=js"

import "./DialogManager.vue?vue&type=style&index=0&id=6447ddb0&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6447ddb0"]])

export default __exports__